import { Component } from "react"
import PropTypes from "prop-types"

import isFeatureEnabled from "shared/featureflags/helperFunctions"

import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    CampaignActionCenterFilter,
    CampaignTypeFilter,
    CampaignStatusFilter,
    CampaignStartDateAfterFilter,
    CampaignStartDateBeforeFilter,
    CampaignEndDateAfterFilter,
    CampaignEndDateBeforeFilter,
    // CampaignNumberActionsFilter,
    // CampaignNumberParticipantsFilter,
    CampaignProjectFilter,
    CampaignInvolvingUserFilter,
} from "shared/search/containers/Filter/CampaignFilters"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

export class CampaignTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [CampaignTypeFilter, ...(!Userdata.has_singular_action_center ? [CampaignActionCenterFilter] : [])],
        uniqueFilterGroupId: "CampaignTypeFilterGroup",
        displayLabel: "Campaign Type",
        helpText: "Filter campaigns by the type of campaign.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CampaignStatusFilterGroup extends Component {
    static defaultProps = {
        filters: [CampaignStatusFilter],
        uniqueFilterGroupId: "CampaignStatusFilterGroup",
        displayLabel: "Campaign Status",
        helpText: "Filter campaigns by their status.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CampaignDateFilterGroup extends Component {
    static defaultProps = {
        filters: [
            CampaignStartDateAfterFilter,
            CampaignStartDateBeforeFilter,
            CampaignEndDateAfterFilter,
            CampaignEndDateBeforeFilter,
        ],
        uniqueFilterGroupId: "CampaignDateFilterGroup",
        displayLabel: "Date",
        helpText: "Filter campaigns by the date they were started and completed.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

// export class CampaignStatisticsFilterGroup extends Component {
//     static defaultProps = {
//         filters: [
//             CampaignNumberActionsFilter,
//             CampaignNumberParticipantsFilter,
//         ],
//         uniqueFilterGroupId: "CampaignStatisticsFilterGroup",
//         displayLabel: "Statistics",
//         helpText: "Filter campaigns by the number of actions and participants",
//     }

//     render() {
//         return genericFilterGroup(this.props)
//     }
// }

export class CampaignProjectFilterGroup extends Component {
    static defaultProps = {
        filters: [inIssueFilter, notInIssueFilter],
        uniqueFilterGroupId: "CampaignProjectFilterGroup",
        displayLabel: "Issues",
        helpText: "Filter results by the issue they are tagged to.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const CampaignCreatorFilterGroup = (props) => genericFilterGroup(props)
CampaignCreatorFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
CampaignCreatorFilterGroup.defaultProps = {
    filters: [CampaignInvolvingUserFilter],
    uniqueFilterGroupId: "CampaignCreatorFilterGroup",
    displayLabel: "Creator",
    helpText: "Filter results by the project they are tagged to.",
}
